import React from 'react';
import { Box } from 'rebass/styled-components';
import LinkAnimated from './LinkAnimated';

const CVLink = () => (
  <Box ml={[2, 3]} color="navtext" fontSize={[2, 3]}>
    <LinkAnimated style={{ cursor: 'pointer' }}>
      <a
        style={{
          color: 'inherit',
          textDecoration: 'inherit',
        }}
        href="https://drive.google.com/file/d/1H80zQmRAqAIV-KhI2oEr2y6Cz69_3AXr/view?usp=sharing"
        target="_blank"
      >
        Resume
      </a>
    </LinkAnimated>
  </Box>
);

export default CVLink;
